/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-template */
import AppConsts from './appconst';
import Util from '../utils/utils';
// import appSettings from '../appSettings';

const { abp } = window;

class SignalRAspNetCoreHelper {
  initSignalR() {
    const encryptedAuthToken = abp.utils.getCookieValue(
      AppConsts.authorization.encrptedAuthTokenName
    );

    abp.signalr = {
      autoConnect: false,
      connect: undefined,
      hubs: undefined,
      qs:
        AppConsts.authorization.encrptedAuthTokenName +
        '=' +
        encodeURIComponent(encryptedAuthToken),
      remoteServiceBaseUrl: window.config.apiUrl, // appSettings.apiUrl,
      startConnection: undefined,
      url: '/signalr',
    };

    Util.loadScript(AppConsts.appBaseUrl + '/dist/abp.signalr-client.js');
  }
}
export default SignalRAspNetCoreHelper = new SignalRAspNetCoreHelper();
